import styles from "./index.module.scss";
import {
  countDaysFromDate,
  formatCurrency,
  numberWithCommas
} from "../../../utils/utils";
import Avatar from "../avatar";
import { Tag } from "primereact/tag";
import { scrollToTop } from "../../../utils/const";
import { useNavigate } from "react-router-dom";
import Like from "../like";
import moment from "moment";
import { useEffect, useState } from "react";
import { NavigateToExchange } from "../../../utils/inv-exch-amplitude";
import { NavigatePropertyDetail } from "../../investor/amplitude";
import PriceDropTag from "../pricedrop-tag";
import { Tooltip } from "primereact/tooltip";

export default function MobilePropertiesCard({
  isPlaceholderData,
  item,
  status,
  refetch,
  type,
  loginType
}: any) {
  const navigate = useNavigate();


  const checkActivationTime = () => {
    if (item?.activatedAt === null) return false;
    return (
      moment.utc().diff(moment.utc(item?.activatedAt), "minutes") >=
      +`${process.env.REACT_APP_ACTIVE_TIMER}`
    );
  };

  const [showIEButton, setShowIEButton] = useState(checkActivationTime);

  useEffect(() => {
    // Initial check
    setShowIEButton(checkActivationTime());

    // Set up interval to check every 5 minutes
    const interval = setInterval(() => {
      setShowIEButton(checkActivationTime());
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [item?.activatedAt]);
  return (
    <div
      className={`${isPlaceholderData ? styles.placeholder : ""} ${
        styles.card
      }`}
      onClick={() => {
        scrollToTop();
        if (loginType === "investor") {
          navigate(`/external/${item.shareKey}`);
          NavigatePropertyDetail({
            propertyId: item?.id,
            propertySFID: item?.propertySFID,
            opportunitySFID: item?.opportunitySFID,
            pubPropertySFID: item?.pubPropertySFID,
            shareId: item?.shareKey,
            address: item?.address,
            bedRooms: item?.bedRooms,
            baths: item?.baths,
            sqft: item?.sqft,
            askingPrice: item?.askingPrice
          });
        } else {
          navigate(`/internal/${item.id}`);
        }
      }}
    >
      <div className={styles.box}>
        <div className={styles.imgBox}>
          <img
            src={item.posterImage}
            alt=""
            // onError={(e: any) => {
            //   e.target.src = "/images/default-property.jpg";
            //   e.target.alt = "Image not available";
            // }}
          />
          <div className={styles.like}>
            <Tag
              value={item?.status}
              style={{
                background: `${status?.bgColor || "#0000008a"}`,
                color: `${status?.txtColor || "#ffffff"}`
              }}
            />

            {loginType === "agent" && (
              <Tag
                value={
                  countDaysFromDate(item?.createdAt) > 1
                    ? `${countDaysFromDate(item?.createdAt)} Days ago`
                    : `${countDaysFromDate(item?.createdAt)} Day ago`
                }
                style={{ background: "#0000008a", color: "#ffffff" }}
              />
            )}
          </div>
          <div className={styles.profileWrap}>
            <div className={styles.profileImg}>
              {loginType === "agent" && (
                <>
                  {item?.acquisitionAgent1 && (
                    <div className={styles.agentWrap}>
                      <Avatar
                        image={item?.acquisitionAgent1?.smallBannerPhotoUrl}
                        label={`${item.acquisitionAgent1?.name?.slice(
                          0,
                          1
                        )}${item.acquisitionAgent1?.name
                          ?.split(" ")[1]
                          ?.slice(0, 1)}`}
                        shape={"circle"}
                      />
                      <div>
                        {item?.acquisitionAgent1?.name && (
                          <div
                            className={`${styles.text} ${
                              !item.imageUrl ? styles.WithoutImg : ""
                            }`}
                          >
                            Listed By
                          </div>
                        )}

                        <div
                          className={`${styles.name} ${
                            !item.imageUrl ? styles.WithoutImg : ""
                          }`}
                        >
                          {item?.acquisitionAgent1?.name?.split(" ")[0]}{" "}
                          {item?.acquisitionAgent1?.name?.split(" ")[1]}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <Tag
              value={item?.salesInstruction}
              style={{ background: "#0000008a", color: "#ffffff" }}
            />
          </div>
        </div>
        <div className={styles.contentBox}>
          <div className={styles.wrapText}>
            <div className={styles.textWrap}>
              <div className={styles.priceWrap}>
                <div className={styles.priceWrap}>
                  <div className={styles.price}>
                    {formatCurrency(+item.askingPrice, "USD", "en-us")}
                  </div>
                  <PriceDropTag
                    type={loginType}
                    priceDrop={item?.priceDrop}
                    priceDropDate={item?.priceDropDate}
                  />
                </div>
                <Like
                  loginType={loginType}
                  propertyId={item.id}
                  favCount={item.favCount}
                  isMobile={true}
                  refetch={refetch}
                  objPropertyDetails={item}
                />
              </div>
              <div className={styles.accessoriesListing}>
                {item.bedRooms && (
                  <span className={styles.accessories}>
                    {item.beds || item.bedRooms} Bed
                  </span>
                )}
                {(item.baths || item.totalBath) && (
                  <span className={styles.accessories}>
                    {item.baths || item.totalBath} Bath
                  </span>
                )}
                {item.sqft && (
                  <span className={styles.accessories}>
                    {numberWithCommas(item.sqft)} Sq.Ft
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className={styles.addressWrap}>
            <div>
              <div className={styles.address}>{item?.street}</div>
              <div className={styles.location}>
                {(item?.city && `${item?.city}, `) +
                  item?.state +
                  " " +
                  item?.postalcode}
              </div>
            </div>
            {loginType === "agent" && (
              <>
                {type !== "popup" && item?.status === "Active" && (
                  <div
                    className={`exchange-${item.id} ${styles.findInvestor} ${
                      checkActivationTime() ? styles.openButton : ""
                    }`}
                    onClick={(e) => {
                      e?.stopPropagation();
                      navigate(
                        `/flipper-vault?pid=${item?.id}&sfid=${item?.sfid}&lat=${item?.latitude}&lng=${item?.longitude}&radius=60&shouldIgnoreRadius=true&price=${item?.askingPrice}&street=${encodeURIComponent(item?.street || "")}&city=${encodeURIComponent(item?.city || "")}&state=${encodeURIComponent(item?.state || "")}&postalCode=${encodeURIComponent(item?.postalcode || "")}&order=High+to+Low&showIEButton=${showIEButton}&view=ALL+ACCOUNTS`
                      );
                      NavigateToExchange({
                        property_id: item?.id,
                        property_sfid: item?.sfid,
                        property_address: `${item?.street}, ${item?.city}, ${item?.state} ${item?.postalCode}`
                      });
                    }}
                  >
                    <Tooltip
                      position="bottom"
                      target={`.exchange-${item?.id}`}
                      className={styles.tooltip}
                      content={moment(item.activatedAt)
                        .utc()
                        .add(48, "hours")
                        .local()
                        .format("MM/DD/YY hh:mm A")}
                    />
                    <img
                      src="/images/exchange.svg"
                      alt=""
                      width={20}
                      height={20}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
